import {MonoTypeOperatorFunction, Observable} from "rxjs";
import {catchError} from "rxjs/operators";
import {ExternalErrorException} from "../exceptions/external-error.exception";
import {ExternalValidationException} from "../exceptions/external-validation.exception";
import { HttpErrorResponse } from "@angular/common/http";

export function parseJSendException<T>(): MonoTypeOperatorFunction<T> {
    return (source: Observable<T>): Observable<T> => {
        return source.pipe(
            catchError((err: HttpErrorResponse) => {
                // Handle validation errors
                if (err.error?.status === 'fail') {
                    throw ExternalValidationException.createFromJsonFailResponse(err.error);
                }

                // Handle server errors
                if (err.error?.status === 'error') {
                    throw ExternalErrorException.createFromJsonErrorResponse(err.error);
                }

                // Fallback
                throw err;
            })
        );
    };
}
